export default __webpack_public_path__ + "static/carlo-94853f1bbb8b91ee988ac2e3c6fcbe70.jpg";